/*****************************************************************************
*
* MCAFEE CONFIDENTIAL
* Copyright (c)2019 McAfee, LLC
*
* The source code contained or described herein and all documents related
* to the source code ("Material") are owned by McAfee or its
* suppliers or licensors. Title to the Material remains with McAfee
* or its suppliers and licensors. The Material contains trade
* secrets and proprietary and confidential information of McAfee or its
* suppliers and licensors. The Material is protected by worldwide copyright
* and trade secret laws and treaty provisions. No part of the Material may
* be used, copied, reproduced, modified, published, uploaded, posted,
* transmitted, distributed, or disclosed in any way without McAfee's prior
* express written permission.
*
* No license under any patent, copyright, trade secret or other intellectual
* property right is granted to or conferred upon you by disclosure or
* delivery of the Materials, either expressly, by implication, inducement,
* estoppel or otherwise. Any license under such intellectual property rights
* must be expressed and approved by McAfee in writing.
*
****************************************************************************/
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { ModuleManager, globalEngine } from "./Init";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";

// #ENDIF WebPack

var createUWPStorage = function ()
{
    var uwp_storage =
    {
     "_content":{},
     "add": function (name, value) {
             if (!name) { return; }

             // a null value is valid, as we could receive a null value, or be replacing an exising value with null

             this._content[name] = value;
     },
     "set": function (key, value, ruleConfig) {
             if (!ruleConfig)
             {
                 this.add(key, value);
                 return;
             }
             var rules = ModuleManager.getSingleton("rules");
             this.add(key, rules.apply(value, ruleConfig));
     },
     "get": function (key)
     {
             try
             {
                // this.load();
                 if (!this._content)
                 {
                     return null;
                 }
                 return this._content[key];
             }
             catch (e)
             {
                 logError('uwp_storage:get: key(' + key + '): ' + e.message);
             }
     },
     "getContent": function ()
     {
             return this._content;
     }

    };
    return uwp_storage;
}

// over-ride the real registry plugin with our mock plugin
ModuleManager.registerFactory("uwp_storage", createUWPStorage);
//export  {createUWPStorage};
//globalEngine.FactoryMap["uwp_storage"] =  createUWPStorage;
